import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 25000 });

export const getConfig = () => http.get("/config").then((r) => r.data);
export const getProducts = (params) => http.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => http.get(`/products/${slug}`).then((r) => r.data);
export const getStoneMeta = (slug) => http.get(`/stones/${slug}`).then((r) => r.data);
export const getServices = () => http.get("/services").then((r) => r.data);
export const getService = (slug) => http.get(`/services/${slug}`).then((r) => r.data);
export const getConsultants = () => http.get("/consultants").then((r) => r.data);
export const getSlots = (params) => http.get("/slots", { params }).then((r) => r.data);
export const createBooking = (body) => http.post("/bookings", body).then((r) => r.data);
export const getBooking = (ref) => http.get(`/bookings/${ref}`).then((r) => r.data);
export const getScoreboard = () => http.get("/scoreboard").then((r) => r.data);
export const getReviews = (params) => http.get("/reviews", { params }).then((r) => r.data);
export const postReview = (body) => http.post("/reviews", body).then((r) => r.data);
export const getLabs = () => http.get("/labs").then((r) => r.data);
export const verifyCertificate = (body) => http.post("/tools/verify-certificate", body).then((r) => r.data);
export const runNumerology = (body) => http.post("/tools/numerology-calculator", body).then((r) => r.data);
export const runRudrakshaFinder = (body) => http.post("/tools/rudraksha-finder", body).then((r) => r.data);
export const getTodaysMuhurat = () => http.get("/muhurat/today").then((r) => r.data);
export const runKundli = (body) => http.post("/tools/free-kundli", body).then((r) => r.data);
export const getFestivals = () => http.get("/festivals").then((r) => r.data);
export const getDelivery = (params) => http.get("/delivery-estimate", { params }).then((r) => r.data);
export const createOrder = (body) => http.post("/orders", body).then((r) => r.data);
export const getOrder = (n) => http.get(`/orders/${n}`).then((r) => r.data);
export const postHoroscopeCheck = (body) => http.post("/horoscope-check", body).then((r) => r.data);
export const postContact = (body) => http.post("/contact", body).then((r) => r.data);
export const joinCommunity = (body) => http.post("/community/join", body).then((r) => r.data);
export const exportData = (email) => http.get("/account/data", { params: { email } }).then((r) => r.data);
export const deleteData = (email) => http.delete("/account/data", { data: { email } }).then((r) => r.data);
export const getOrderBumps = () => http.get("/order-bumps").then((r) => r.data);
export const emailToolResult = (body) => http.post("/tools/email-result", body).then((r) => r.data);
export const cartCheckpoint = (body) => http.post("/cart/checkpoint", body).then((r) => r.data);
export const getMukhiAvailability = () => http.get("/mukhi-availability").then((r) => r.data);
export const postCustomizeInquiry = (body) => http.post("/customize-inquiry", body).then((r) => r.data);

export const apiError = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong. Please try again.";
